import { Fragment } from 'react'
import { Form, Formik } from 'formik'

import { EMPTY_OBJECT } from '../../../constants/common'

function FormikForm({
  Component = Form,
  Container = Fragment,
  children,
  containerProps,
  formProps,
  initialValues = EMPTY_OBJECT,
  ...formikProps
}) {
  return (
    <Formik {...formikProps} initialValues={initialValues}>
      <Container {...containerProps}>
        <Component {...formProps}>{children}</Component>
      </Container>
    </Formik>
  )
}

export default FormikForm
